import React, { useEffect, useState } from 'react';
import { FaSeedling } from 'react-icons/fa';
import './FertilizerResourcePage.css';

const FertilizerResourcePage = () => {
  const [fertilizerData, setFertilizerData] = useState([
    { product: "Sagar King (Hybrid) Watermelon Sagar Seeds", price: "₹1,30,000", rating: "★★★★★", soldOut: false },
    { product: "MaxoFresh (Hybrid) Watermelon (Nunhem)", price: "₹1,59,400", rating: "★★★★★", soldOut: false },
    { product: "Saaho (TO-351) Tomato (Syngenta)", price: "₹1,05,000", rating: "★★★★★", soldOut: false },
    { product: "Green Magic F1 Hybrid Broccoli (Sakata)", price: "₹1,45,000", rating: "★★★★★", soldOut: false },
    { product: "Salt F1 Hybrid Broccoli (Sakata)", price: "₹9,98,000", rating: "★★★★★", soldOut: false },
    { product: "Watermelon (Hybrid) Seeds (Disease-Free)", price: "₹2,29,000", rating: "★★★★★", soldOut: true },
    { product: "Lantus F1 Hybrid IceBox Watermelon (Konko Seeds)", price: "₹1,45,000", rating: "★★★★★", soldOut: false },
    { product: "Lyleup F1 Hybrid Mushroom (BASF-Nunhem)", price: "₹1,44,900", rating: "★★★★★", soldOut: true },
    { product: "Maten F1 Hybrid Onion (Nunhem)", price: "₹3,20,000", rating: "★★★★★ (0)", soldOut: true },
    { product: "Golden Glory (Fresh) Watermelon Field Seeds", price: "₹1,54,900", rating: "★★★★★", soldOut: true },
    { product: "Bheemraj F1 Hybrid Seedless Watermelon (Konko Seeds)", price: "₹1,50,000", rating: "★★★★★", soldOut: false },
    { product: "Yellow (307 F1) Hybrid Mergold (Sakata Seeds)", price: "₹1,65,000", rating: "★★★★★", soldOut: false },
    { product: "Vahalam F1 Hybrid Type Box-Red Flesh Watermelon Seeds (Neemsoil)", price: "₹7,86,000", rating: "★★★★★", soldOut: false },
    { product: "Kalium + Potassium Mobilizing (Zoospore Biologicals)", price: "₹73.00", rating: "★★★★★", soldOut: false },
    { product: "Biozol (Zoospore Mobilizing)", price: "₹550.00", rating: "★★★★★", soldOut: false },
    { product: "Wormize - Densmore Waterbased Humate (Zoospore Biologicals)", price: "₹599.00", rating: "★★★★★", soldOut: false },
    { product: "Humax (40% Humic Acid)", price: "₹2,50.00", rating: "★★★★★", soldOut: false },
    { product: "Neemsoil - Neem Oil (0.15% 1500 ppm) (Zoospore Biologicals)", price: "₹460.00", rating: "★★★★★", soldOut: false }
  ]);
  const [loading, setLoading] = useState(false);
  const [lastRefresh] = useState(new Date());

  useEffect(() => {
    // Static data is already set, no API call needed
  }, []);

  return (
    <div style={{ fontFamily: "Poppins, sans-serif", backgroundColor: "#f0f4f7", minHeight: "100vh" }}>
      {/* HEADER */}
      <div className="fertilizer-resource-header" style={{
        background: "linear-gradient(90deg, #28a745 0%, #218838 100%)",
        color: "white",
        padding: "40px 20px",
        textAlign: "center",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
      }}>
        <h1 style={{ fontSize: "clamp(22px, 4vw, 40px)", marginBottom: "8px", fontWeight: "700", display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
          <FaSeedling /> Seasonal Seeds for Farmers!!
        </h1>
        <p style={{ fontSize: "18px", opacity: "0.9", maxWidth: "650px", margin: "auto" }}>
          Explore the best seasonal seeds to boost your farming yield with top-quality products.
        </p>
      </div>

      <div className="fertilizer-resource-body" style={{ padding: '30px', fontFamily: 'Arial' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <span style={{ fontSize: '14px', color: '#666' }}>
            Last updated: {lastRefresh.toLocaleTimeString()}
          </span>
        </div>

        {!loading && (
          <>
            <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f0f8ff', borderRadius: '5px' }}>
              <p style={{ margin: 0, fontSize: '14px', color: '#333' }}>
                📊 Showing {fertilizerData.length} seed records
              </p>
            </div>

            <div className="fertilizer-resource-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: '25px'
            }}>
              {fertilizerData.map((item, index) => (
                <div
                  key={index}
                  style={{
                    border: 'none',
                    padding: '25px',
                    borderRadius: '16px',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer',
                    position: 'relative',
                    overflow: 'hidden',
                    minHeight: '180px',
                    opacity: item.soldOut ? 0.5 : 1
                  }}
                  onMouseEnter={(e) => {
                    if (!item.soldOut) {
                      e.currentTarget.style.transform = 'scale(1.03)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.12)';
                  }}
                >
                  {item.soldOut && (
                    <div style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      backgroundColor: '#ff4444',
                      color: 'white',
                      padding: '5px 10px',
                      borderRadius: '5px',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}>
                      Sold Out
                    </div>
                  )}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '50px',
                    height: '50px',
                    background: 'linear-gradient(45deg, #4CAF50, #81C784)',
                    clipPath: 'polygon(0 0, 100% 0, 0 100%)',
                    opacity: 0.3
                  }}></div>

                  <h3 style={{
                    margin: '0 0 20px 0',
                    color: '#1a3c6e',
                    fontSize: '22px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}>
                    <FaSeedling style={{ color: '#4CAF50', fontSize: '24px' }} />
                    {item.product}
                  </h3>

                  <div style={{ display: 'grid', gap: '12px' }}>
                    <p style={{
                      margin: 0,
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: '16px',
                      color: '#333'
                    }}>
                      <span><strong>Price:</strong></span>
                      <span style={{ color: '#2e7d2e' }}>{item.price}</span>
                    </p>
                    {item.rating && (
                      <p style={{
                        margin: 0,
                        display: 'flex',
                        justifyContent: 'space-between',
                        background: 'linear-gradient(90deg, #e8f5e8, #f1f8e9)',
                        padding: '10px',
                        borderRadius: '8px',
                        fontWeight: '600',
                        fontSize: '16px'
                      }}>
                        <span><strong>Rating:</strong></span>
                        <span>{item.rating}</span>
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {fertilizerData.length === 0 && (
              <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                <p>No seed data available at the moment.</p>
              </div>
            )}
          </>
        )}

        <div style={{
          textAlign: 'center',
          marginTop: '30px'
        }}>
        </div>

        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default FertilizerResourcePage;